import { doSearch } from 'actions/search';
import { convertCustomProps } from 'utils/event';

export const SEARCH = 'SEARCH_EVENTS';
export const SEARCH_START = `${SEARCH}_START`;
export const SEARCH_SUCCESS = `${SEARCH}_SUCCESS`;
export const SEARCH_FAIL = `${SEARCH}_FAIL`;

export const LOAD_MORE = 'LOAD_MORE_EVENTS';
export const LOAD_MORE_START = `${LOAD_MORE}_START`;
export const LOAD_MORE_SUCCESS = `${LOAD_MORE}_SUCCESS`;
export const LOAD_MORE_FAIL = `${LOAD_MORE}_FAIL`;

export const PAGE = 'PAGE_EVENTS';
export const PAGE_START = `${PAGE}_START`;
export const PAGE_SUCCESS = `${PAGE}_SUCCESS`;
export const PAGE_FAIL = `${PAGE}_FAIL`;

export const COUNT = 'COUNT_EVENTS';
export const COUNT_START = `${COUNT}_START`;
export const COUNT_SUCCESS = `${COUNT}_SUCCESS`;
export const COUNT_FAIL = `${COUNT}_FAIL`;

const returnEncodedURI = uriParam => uriParam;

export function getPage(nextLink) {
  return {
    type: PAGE,
    meta: {
      xmApi: true,
      method: 'get',
      uri: nextLink,
      customUriWithParamsGenerator: returnEncodedURI,
    },
  };
}

export function getCount(countUri, params) {
  return {
    type: COUNT,
    meta: {
      xmApi: true,
      method: 'get',
      uri: countUri,
      params: {
        ...convertCustomProps(params),
        offset: 0,
        limit: 0,
        exclude: '',
      },
    },
    payload: params,
  };
}

export const doEventsSearch = ({
  uri,
  params,
  type = SEARCH,
  method = 'get',
}) => {
  return doSearch(uri, convertCustomProps(params), type, method);
};

export const CLEAR = 'events/CLEAR';

export function clear() {
  return {
    type: CLEAR,
  };
}
